<template>
	<div>
		<div class="header_extend_main">
			<!-- <myheader :backFlag="true" headTitle="企业管理"></myheader> -->
			<!-- <div class="all_list_main"> -->
			<div class="all_header_right">
				<img src="../../assets/images/add.svg" style="width:1.2rem;margin:.5rem;" @click="showBottom = true" />
			</div>
			<div id="list" class="all_list_content_nopadding" style="padding-bottom: 3rem;">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div style="min-height: 70vh;height: auto;">
						<div v-for="(item, index) in list" :key="index" v-show="list.length > 0">
							<div class="enterprise">
								<div class="display_flex" style="width: 85%;">
									<span
										class="all_line_height10 text14 textcolor333 font_weight_900 display_inline_block"
										style="max-width:80%;">
										{{ item.corpName }}</span>
									<!-- v-if="item.corpStatus !== 0&&item.corpStatus !== 3" -->
									<span class="all_line_height10 text12 display_inline_block" :class="{
										textcolorAuth: item.corpStatus === 2 || item.corpStatus === 6,
										textcolorNopass: item.corpStatus === 4 || item.corpStatus === 7,
										textcoloraaa: item.corpStatus === 0 || item.corpStatus === 1 || item.corpStatus === 3 || item.corpStatus === 5
									}" style="width: 20%;padding: 0 .5rem;">{{ item.corpStatusText }}</span>
								</div>
								<div class="all_height_line16 text12 textcolor666">
									{{ '企业代码 ' + item.creditCode }}
								</div>
								<div v-if="item.corpStatus !== 0" class="status">
									<img :src="item.corpStatus === 2 ? menu : right"
										style="height: 0.8rem;margin: 0.8rem;margin: .5rem;"
										@click="enterpriseDetail(item, index)" />
								</div>
								<!-- <div class="text14 status" @click="enterpriseDetail(item,index)">
									{{ item.corpStatus === 1? '管理':'查看'}}
								</div> -->
							</div>
							<div class="horizontal_line"></div>
						</div>
						<van-empty style="margin-top: 20vh;margin-bottom: 20vh;" description="暂无数据"
							v-show="list.length == 0" />
					</div>
				</van-pull-refresh>
			</div>
			<!-- <div class="text14 all_text_center all_tips_bottom_card"
					style="bottom: .5rem;width: 50%;margin: 0 25%;border: 1px solid #17aaed;color:#17aaed;border-radius: .2rem;"
					@click="showBottom = true">
					+ 添加绑定企业
				</div> -->
			<!-- </div> -->
		</div>
		<van-popup v-model:show="showBottom" position="bottom">
			<div class="addEnterpriseList">
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="authEnterprise()">
					<img style="width:2rem; height: 2rem; margin:.5rem .8rem;"
						src="@/assets/images/auth_enterprise.svg">
					<div style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900">认证企业</div>
						<div class="text12 textcolor999">上传企业信息，进行企业认证</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="joinEnterprise()">
					<img style="width:2rem;height: 2rem; margin:.5rem .8rem;" src="@/assets/images/join_enterprise.svg">
					<div style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900">加入企业</div>
						<div class="text12 textcolor999">加入已经完成认证的企业</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="all_height_line24 text14 textcolor999 all_text_center" @click="showBottom = false">取&nbsp;消
				</div>
			</div>
		</van-popup>
		<van-popup v-model:show="showManagerBottom" position="bottom">
			<div class="addEnterpriseList">
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="managerSeal()">
					<img style="width:2rem; height: 2rem; margin:.5rem .8rem;"
						src="@/assets/images/auth_enterprise.svg">
					<div style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900">企业印章</div>
						<div class="text12 textcolor999">添加管理企业印章</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="managerMember()">
					<img style="width:2rem;height: 2rem; margin:.5rem .8rem;" src="@/assets/images/join_enterprise.svg">
					<div style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900">企业成员</div>
						<div class="text12 textcolor999">查看管理企业成员</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="managerAuth()">
					<img style="width:2rem;height: 2rem; margin:.5rem .8rem;" src="@/assets/images/join_enterprise.svg">
					<div style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900">重新认证</div>
						<div class="text12 textcolor999">更新企业信息</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="onChangeAuth()">
					<img style="width:2rem;height: 2rem; margin:.5rem .8rem;" src="@/assets/images/cert-auth.svg">
					<div style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900">变更授权</div>
						<div class="text12 textcolor999">变更证书办理人</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="all_height_line24 text14 textcolor999 all_text_center" @click="showManagerBottom = false">
					取&nbsp;消
				</div>
			</div>
		</van-popup>
		<!-- 变更授权弹框 -->
		<change-auth-dialog :show.sync="showChangeAuthDialog" :corp-id="currentCorpId"
			@confirm="handleChangeAuthConfirm" />
	</div>
</template>

<script>
import Vue from "vue";
import {
	Empty,
	PullRefresh,
} from "vant";
import ChangeAuthDialog from './modules/changeAuthDialog.vue';
export default {
	name: 'enterpriselist',
	components: {
		[Empty.name]: Empty,
		[PullRefresh.name]: PullRefresh,
		ChangeAuthDialog,
	},
	data() {
		return {
			//企业列表
			list: [],
			//认证方式弹窗
			showBottom: false,
			//管理企业方式弹窗
			showManagerBottom: false,
			//是否下拉刷新
			refreshing: false,
			//滑动高度
			scrollTop: 0,
			//滑动列表
			listView: null,
			//操作的item
			selectIndex: -1,
			menu: require('@/assets/images/menu.svg'),
			right: require('@/assets/images/u359.png'),
			// 变更授权弹框
			showChangeAuthDialog: false,
			// 当前操作的企业ID
			currentCorpId: ''
		}
	},
	activated() {
		this.showBottom = false
		this.showManagerBottom = false
		//console.log('enterpriselist-activated', this.scrollTop)
		if (this.scrollTop != 0) {
			this.listView.scrollTop = this.scrollTop
		}
		//删除某一条数据
		if (this.$store.state.enterpriseDelete && this.selectIndex != -1) {
			this.list.splice(this.selectIndex, 1)
			this.$store.commit('changeEnterpriseDelete', false)
		}
		//刷新某一条数据
		// if (this.$store.state.enterpriseRefresh && this.selectIndex === -1) {
		// 	this.onRefresh()
		// 	this.$store.commit('changeEnterpriseRefresh', false)
		// }
		//刷新整个数据
		if (this.$store.state.enterpriseRefresh) {
			this.onRefresh()
			this.$store.commit('changeEnterpriseRefresh', false)
		}
	},
	deactivated() {
		//console.log('enterpriselist-deactivated')
	},
	//拦截设置keepalive是否缓存
	beforeRouteLeave(to, from, next) {
		//console.log("el-beforeRouteLeave", to, from);
		if (to.meta.index > from.meta.index) {
			if (from.meta.keepAlive) {
				this.$store.commit('addKeepAlive', from.name);
			}
		} else {
			if (from.meta.keepAlive) {
				this.$store.commit('removeKeepAlive', from.name);
			}
		}
		//console.log(this.$store.state.keepAlive)
		next();
	},
	methods: {
		//管理印章
		managerSeal() {
			this.showManagerBottom = false
			this.$router.push({
				path: '/signetlist',
				query: {
					corpId: this.list[this.selectIndex].corpId,
				}
			})
		},
		//管理成员
		managerMember() {
			this.showManagerBottom = false
			this.$router.push({
				path: '/enterprisemembermanage',
				query: {
					corpId: this.list[this.selectIndex].corpId,
					corpName: this.list[this.selectIndex].corpName,
					canAdmin: this.list[this.selectIndex].canAdmin
				}
			})
		},
		//管理重新认证
		//reAuth === 1
		managerAuth() {
			this.showManagerBottom = false
			this.$router.push({
				path: '/authenterpriseinfo',
				query: {
					corpId: this.list[this.selectIndex].corpId,
					reAuth: 1
				}
			})
		},
		onChangeAuth() { //变更授权
			this.showManagerBottom = false;
			this.currentCorpId = this.list[this.selectIndex].corpId;
			this.showChangeAuthDialog = true;
		},
		// 变更授权确认
		handleChangeAuthConfirm(params) {
			this.showChangeAuthDialog = false;
			this.onRefresh()
			this.init()
		},
		//跳转企业认证页面
		authEnterprise() {
			this.showBottom = false
			this.$router.push({
				path: '/authenterpriseinfo'
			})
		},
		//跳转加入企业页面
		joinEnterprise() {
			this.showBottom = false
			this.$router.push({
				path: '/joinenterprise'
			})
		},
		//跳转企业详情页面
		// 0 草稿、1 认证中、2已认证、3废弃、4 未通过、5 审批中、6 已加入、7 已驳回
		// 1 分两个状态 auditState  FOUR_CERTIFIED(1,"四要素通过"),PAY_APPROVING(2,"打款审核中"),
		// reAuth === 3
		enterpriseDetail(item, index) {
			console.log('enterpriseDetail-=', item)
			// item.corpStatus = 4
			// item.auditState = 1
			this.selectIndex = index
			switch (item.corpStatus) {
				case 2:
					this.showManagerBottom = true
					break;
				case 1:
					//
					if (item.auditState === 1) {
						this.$router.push({
							path: '/authenterpriselegal',
							query: {
								corpId: item.corpId,
								reAuth: 3,
							}
						})
					} else {
						this.$router.push({
							path: '/authenterprisestatus',
							query: {
								applyId: item.corpApplyId,
								corpId: item.corpId,
								corpName: item.corpName,
								certifyStatusText: item.corpStatusText,
								applyStatus: item.corpStatus
							}
						})
					}
					break;
				case 4:
					this.$router.push({
						path: '/authenterprisestatus',
						query: {
							applyId: item.corpApplyId,
							corpId: item.corpId,
							corpName: item.corpName,
							certifyStatusText: item.corpStatusText,
							applyStatus: item.corpStatus,
							auditMemo: item.auditMemo
						}
					})
					break;
				case 5:
				case 6:
				case 7:
					this.$router.push({
						path: '/joinenterprisestatus',
						query: {
							applyId: item.staffCorpApplyId,
							corpId: item.corpId,
							corpName: item.corpName,
							certifyStatusText: item.corpStatusText,
							//applyStatus: item.corpStatus
						}
					})
					break;
			}
		},
		// 下拉刷新
		onRefresh() {
			this.getEnterpriseList()
		},
		//获取企业列表数据
		getEnterpriseList() {
			// 清空列表数据
			if (this.refreshing) {
				this.list = [];
				this.refreshing = false;
			}
			this.$store.dispatch(this.$LoadShow, true)
			this.$post("/corp/m/api/getManagedCorps").then((res) => {
				this.$store.dispatch(this.$LoadShow, false)
				if (res.success && res.data) {
					this.list = res.data
				} else {
					this.$Toast(res.message || res.mesageDetail || '获取企业列表失败！')
				}
			})
		},
		//初始化
		init() {
			this.listView = document.getElementById('list')
			this.listView.addEventListener("scroll", (e) => {
				//记录位置
				this.scrollTop = this.listView.scrollTop
			});
			// let isAuth = this.$route.query.isAuth
			// if (isAuth) {
			// 	this.showBottom = true
			// }
		},
	},
	mounted() {
		this.onRefresh()
		this.init()
	},
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";

.enterprise {
	position: relative;
	padding: .5rem .8rem;
	background-color: white;

	// .status {
	// 	position: absolute;
	// 	display: flex;
	// 	top: 1rem;
	// 	right: 1rem;
	// 	padding: .2rem .5rem;
	// 	border-radius: .1rem;
	// 	border: 1px solid #17aaed;
	// 	color: #17aaed;
	// 	border-radius: .2rem;
	// }
	.status {
		position: absolute;
		display: flex;
		top: .5rem;
		right: .5rem;
	}

	// .passed {
	// 	color: #66BE74;
	// 	border: 1px solid #66BE74;
	// }

	// .passed::before {
	// 	content: url('../../assets/images/enter_auth_passed.svg');
	// 	display: inline-block;
	// 	width: .6rem;
	// 	height: .6rem;
	// 	margin-top: -.1rem;
	// 	margin-left: -.3rem;
	// 	margin-right: .3rem;
	// 	transform: scale(0.5);
	// }

	// .passing {
	// 	color: #FAAD15;
	// 	border: 1px solid #FAAD15;
	// }

	// .nopassed {
	// 	color: #DF4545;
	// 	border: 1px solid #DF4545;
	// }

}

.addEnterpriseList {
	position: relative;

	.style {
		height: 3rem;
	}
}
</style>